export enum ItemStatusEnum {
    OPEN = 'OPEN',
    INPROGRESS = "INPROGRESS",
    ACCEPTED = 'ACCEPTED',
    FAILED = 'FAILED',
    SUCCESS = 'SUCCESS'
  }
